import React, { useEffect } from 'react';
import axios from '../../utils/axios';

import SearchResults from '../../components/service/SearchResults';
import SEO from '../../components/SEO';
import { useDispatch, useSelector } from 'react-redux';
import HiddenText from 'components/service/HiddenText';
import { TOGGLE_SEARCHBAR } from 'actions/types';

const SearchQuery = ({ pros, serviceId, proServices, questions, sn, service, questionTexts, reviews }) => {
    const lang = useSelector((state) => state.settings.lang);
    const settingsState = useSelector((state) => state.settings);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({
            type: TOGGLE_SEARCHBAR,
            payload: false
        });
    }, []);

    const sName =
    lang === 'ru'
        ? service.titleRU
        : lang === 'uz'
            ? service.titleUZ
            : service.titleEN;

    const keywords = service && service.keywords
        ? service.keywords.slice(0,10).join(',')
        : undefined;
    return (
        <>
            <SEO title={sName} description={service?.MetaDescription} keywords={keywords}/>
            <SearchResults
                pros={pros}
                reviews={reviews}
                questionTexts={questionTexts}
                proServices={proServices}
                serviceId={serviceId}
                lang={settingsState.lang}
                sn={sn}
                questions={questions}
                service={service}
            />
            {lang!=='eng'&&
            <HiddenText service={service}     lang={settingsState.lang}/>}
        </>
    );
};

SearchQuery.getInitialProps = async (ctx) => {

    const servicePromise = axios.get(
        `${process.env.BACKEND_URL}/api/v3/services/${ctx.query.serviceId}`
    );

    const prosPromise = axios.get(
        `${process.env.BACKEND_URL}/api/v3/services/${ctx.query.serviceId}/pros`
    );

    const questionsPromise = axios.get(
        `${process.env.BACKEND_URL}/api/v3/services/${ctx.query.serviceId}/questions`
    );

    const [
        { data: service },
        { data: pros },
        { data: questions },
    ] = await Promise.all([servicePromise, prosPromise, questionsPromise]);

    const proIds = pros.map(({ id }) => id);
    const proServicesPromise = await axios.get(
        `${process.env.BACKEND_URL}/api/v3/pros/${pros.length>0?proIds+'/':'0/'}proServices/${ctx.query.serviceId}`
    );

    const reviewsPromise = axios.get(
        `${process.env.BACKEND_URL}/api/v3/pros/${pros.length>0?proIds+'/':'0/'}reviews`
    );

    const [
        { data: proServices },
        { data: reviews },
    ] = await Promise.all([proServicesPromise, reviewsPromise]);

    const quetionIds = questions.map(({ id }) => id);
    const { data: questionTexts } = await axios.get(
        `${process.env.BACKEND_URL}/api/v3/questions/${questions.length>0?quetionIds+'/':'0/'}questionTexts`
    );
    return {
        pros,
        proServices,
        serviceId: ctx.query.serviceId,
        sn: ctx.query.sn,
        service,
        questions,
        questionTexts,
        reviews,
    };
};

export default SearchQuery;
